import { Link } from "react-router-dom";
import neutralLogo from '../../assets/neutralDuduLogo.svg';
import logo from '../../assets/DuduLogo.svg';
import './header.scss';
import { useMediaQuery } from "react-responsive";
import { RiMenu4Fill } from "react-icons/ri";
import { useState } from "react";
import { RxCross2 } from "react-icons/rx";


export default function Header({ isHomepage = true, }) {
    const isMediumScreen = useMediaQuery({ query: '(max-width: 850px)' });
    const [mobileMenu, setMobielMenu] = useState(false);
    const handleHome = () => {
        window.location.href = '/';
    }

    const handleMobileMenu = () => {
        setMobielMenu((prev) => !prev)
    }

    // const handleMobileMenu = () => {
    //     setMobielMenu((prev) => !prev)
    // }

    return (
        <div id="header" className="header--container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            {
                isHomepage &&
                <img onClick={handleHome} style={{ marginTop: isMediumScreen ? '16px' : '', cursor: 'pointer' }} src={neutralLogo} alt="neutral dudu world logo" />
            }
            {
                !isHomepage &&
                <img onClick={handleHome} style={{ marginTop: isMediumScreen ? '16px' : '', cursor: 'pointer' }} src={logo} alt="regular dudu world logo" />
            }
            {
                !isMediumScreen &&
                <div style={{ color: isHomepage ? '#FBF4E5' : '#916859', width: '369px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                    <Link to={'/about'} style={{ color: isHomepage ? '#FBF4E5' : '#916859', cursor: 'pointer' }}>About</Link>
                    <Link to={'/loadgallery'} style={{ color: isHomepage ? '#FBF4E5' : '#916859', cursor: 'pointer' }}>Gallery</Link>
                    <Link to={'/explore'} style={{ color: isHomepage ? '#FBF4E5' : '#916859', cursor: 'pointer' }}>Explore</Link>
                </div>
            }
            {
                !isMediumScreen &&
                <Link to={'/contact'} style={{ opacity: 1, padding: '18px 24px', borderRadius: '100px', border: isHomepage ? `solid 1.6px #FBF4E5` : `solid 1.6px #916859` }}>
                    <p style={{ fontSize: '18px', color: isHomepage ? '#FBF4E5' : '#916859', cursor: 'pointer' }}>Contact Us</p>
                </Link>
            }
            {isMediumScreen && !mobileMenu &&
                <RiMenu4Fill onClick={handleMobileMenu} color={isHomepage ? 'white' : '#916859'} fontSize={32} />
            }
            {
                isMediumScreen && mobileMenu &&
                <div className="mobile-menu">
                    <div style={{ position: 'relative', width: '70%', display: 'flex', justifyContent: 'space-between', justifySelf: 'center', left: '15%', alignItems: 'center', marginTop: '40px' }}>
                        <img onClick={handleHome} style={{ position: 'relative', marginTop: isMediumScreen ? '16px' : '', cursor: 'pointer' }} src={neutralLogo} alt="regular dudu world logo" />
                        <RxCross2 onClick={handleMobileMenu} fontSize={24} color="white" style={{ position: 'relative', }} />
                    </div>
                    <div className="mobile-menu1">
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="/about">About</a></li>
                            <li><a href="/loadgallery">Gallery</a></li>
                            <li><a href="/explore">Services</a></li>
                            <li><a href="/contact">Contact</a></li>
                        </ul>
                    </div>
                    <div className="mobile-menu2" style={{position: "relative", marginBottom: '24px', justifySelf: 'center', left: '10%', textAlign: 'center'}}>
                        <p style={{fontSize: '13px', lineHeight: '22px'}}>
                            Copyright © 2024 Dudu&apos;s World of Entertainment. All rights reserved.
                        </p>
                    </div>
                </div>
            }
        </div>
    )
}